import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useWhatsAppSettings, generateWhatsAppLink } from '../hooks/useWhatsAppSettings';

const WhatsAppButton = ({ user, onLoginClick }) => {
  const { settings } = useWhatsAppSettings();

  if (!settings.whatsappEnabled) return null;

  const handleClick = (e) => {
    if (!user) {
      e.preventDefault();
      if (onLoginClick) {
        onLoginClick();
      }
      return;
    }
  };

  const whatsappLink = generateWhatsAppLink(
    settings.whatsappNumber,
    settings.whatsappMessage || "Hello, I need help with real estate"
  );

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110"
      title="Chat on WhatsApp"
    >
      <FaWhatsapp className="text-white text-2xl" />
    </a>
  );
};

export default WhatsAppButton;
